import { gql } from '@apollo/client';
export const CREATE_API_KEY = gql `
  mutation CreateApiKey($input: CreateClientInput!) {
    createWebApiClient(input: $input) {
      id
      clientSecret
      clientId
      name
      description
      createdBy
      createdByCompanyUser {
        user {
          name
        }
      }
    }
  }
`;
